import cn from 'classnames';
import Link from 'next/link';
import React from 'react';

import s from './ALink.module.scss';

export interface IALinkProps extends React.HTMLAttributes<HTMLAnchorElement> {
  href?: string;
  target?: '_blank' | '_self';
  scroll?: boolean;
  onClick?: () => void;
  prefetch?: boolean;
}

const ALink: React.FC<IALinkProps> = (props: IALinkProps) => {
  const {
    href,
    children,
    className,
    target = '_self',
    scroll = undefined,
    onClick,
    prefetch = true,
  } = props;

  if (!href) {
    return (
      <span className={cn([s.link, className])} onClick={onClick}>
        {children}
      </span>
    );
  }

  return (
    <Link href={href} prefetch={prefetch} scroll={scroll}>
      <a className={cn([s.link, className])} target={target} onClick={onClick}>
        {children}
      </a>
    </Link>
  );
};

export default ALink;
